import React from "react";
import { TypeAnimation } from "react-type-animation";
import "./Loader.css";
import BFCSignIN from "@/assets/svg/LoginPage/BFCSignIN";

type LoaderProps = {
  size?: number;
  fullscreen?: boolean;
  className?: string | undefined;
};

const Loader: React.FC<LoaderProps> = ({
  size = 120,
  fullscreen = true,
  className,
}) => {
  const wrapperClassName = [
    "loaderWrapper",
    !fullscreen ? "loaderInlineWrapper" : "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClassName}>
      <div className="ambientGlow" />
      <div className="ambientGlow secondaryGlow" />

      <div className="loaderContent">
        <div
          className="logoContainer"
          style={{ width: size, height: size }}
        >
          <div className="logoGlow" />

          <div className="bfcLogo">
            <BFCSignIN width={size * 0.8} height={size * 0.8} />
          </div>
        </div>

        <div className="loaderTextWrap">
          <TypeAnimation
            sequence={[
              500,
              "Curating meaningful conversations...",
              1400,
              "Connecting visionary founders...",
              1400,
              "Building valuable investor networks...",
            ]}
            speed={58}
            repeat={Infinity}
            cursor={false}
            className="loaderText"
          />
        </div>

        <div className="progressLine">
          <div className="progressFill" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
